<template>
  <banner :message="mergeTitle"
          class="merge-info-banner">
    <p class="merge-info-banner__text">{{ noChangesMessage }}</p>
    <p class="merge-info-banner__text">{{ laterChangesMessage }}</p>
  </banner>
</template>

<script>
  import Banner from '@/components/shared_components/banners/Banner';

  export default {
    components: {
      banner: Banner
    },
    computed: {
      mergeTitle() {
        return this.$gettext('Salita and Tolkenett have merged.');
      },
      noChangesMessage() {
        return this.$gettext('As a freelancer this does not change how you take assignments. You should continue to take assignments as usual via MySalita.');
      },
      laterChangesMessage() {
        return this.$gettext('If changes that affect you as a freelancer arrive at a later stage, you will be informed about them in good time.');
      }
    }
  };
</script>

<style scoped>
  .merge-info-banner.banner {
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% - 30px);
    margin: 15px auto 0;
    text-align: left;
  }

  .merge-info-banner__text {
    margin-top: 8px;
    font-weight: normal;
    font-size: 14px;
  }

  @media (max-width: 767px) {
    .merge-info-banner.banner {
      width: 100%;
      margin-top: 0;
    }
  }
</style>
